import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import UpdateUnit from "./UpdateUnit";
import Delete from "../Include/Delete"
import { DELETE_UNIT } from "../../Schema/Unit";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";

export default function UnitAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  // console.log("editData::",editData)

  const [deleteUnit] = useMutation(DELETE_UNIT, {
    onCompleted: ({ deleteUnit }) => {
      // console.log("deleteUnit::", deleteUnit);
      setLoading(false);
      if (deleteUnit?.status === true) {
        setAlert(true, "success", deleteUnit?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteUnit?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteUnit({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
            onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {
        openEdit && (
          <UpdateUnit
            open={openEdit}
            handleClose={handleCloseEdit}
            editData={editData}
            setRefetch={setRefetch}
          />
        )
      }
      {/* <DeleteUnit
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      /> */}
      {
        openDel && (
          <Delete
            open={openDel}
            handleClose={handleCloseDel}
            title={"Unit"}
            loading={loading}
            handleDelete={handleDelete}
          />
        )
      }
    </div>
  );
}
